import { defineStore } from 'pinia'
import { facebookScript, twitterScript } from '~/utils/social'

type TStoreState = {
  facebook: boolean;
  twitter: boolean;
};

export const useCdnStore = defineStore('cdn', {
  state: (): TStoreState => {
    return {
      facebook: false,
      twitter: false
    }
  },
  actions: {
    initFacebook () {
      if (window.FB) {
        window.FB.XFBML.parse()
      }
    },
    loadFacebook () {
      if (!window.FB) {
        facebookScript(() => {
          this.$state.facebook = true
          this.initFacebook()
        })
      } else {
        this.initFacebook()
      }
    },
    initTwitter () {
      if (window.twttr && window.twttr.widgets && window.twttr.widgets.load) {
        window.twttr.widgets.load()
      }
    },
    loadTwitter () {
      if (!window.twttr) {
        twitterScript(() => {
          this.$state.twitter = true
          this.initTwitter()
        })
      } else {
        this.initTwitter()
      }
    }
  }
})
